import maps from '@gritdigital/ui/packages/maps'

const maps_api_key = document.querySelector('meta[name="gmaps-key"]').content

maps.init(maps_api_key)
